import { Box, Typography } from "@mui/material";
import EmailIcon from '@mui/icons-material/Email';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import SmsIcon from '@mui/icons-material/Sms';
import AmaruIcon from "@/icons/AmaruIcon";



interface ChannelStats {
    email: number;
    whatsapp: number;
    sms: number;
    push: number;
}

interface ContactsSummaryCardProps {
  channelStats: ChannelStats;
}

interface ChannelRowProps {
  icon: React.ReactNode;
  count: number;
}

const ChannelRow = ({ icon, count }: ChannelRowProps) => (
  <Box
    sx={{
      width: 0.8,
      display: 'flex',
    }}
  >
    <Box
      sx={{
        width: 0.5,
        display: 'flex',
        justifyContent: 'center'
      }}
    >
      <Typography variant='h6'>{`${count} Destinatarios`}</Typography>
    </Box>

    <Box
      sx={{
        width: 0.5,
        display: 'flex',
        justifyContent: 'center'
      }}
    >
      {icon}
    </Box>
  </Box>

);

export const ContactsSumaryCard = ({ channelStats }: ContactsSummaryCardProps ) => {
  const channels = [
    { icon: <EmailIcon />, count: channelStats.email },
    { icon: <WhatsAppIcon />, count: channelStats.whatsapp },
    { icon: <SmsIcon />, count: channelStats.sms },
    { icon: <AmaruIcon />, count: channelStats.push },
  ]

  return (
    <>
    <Box
      sx={{
        border: '1px solid white',
        borderRadius: 1,
        display: 'flex',
        justifyContent: 'center',
        width: 1,
        p: 1
      }}
    >
      <Typography>Destinatarios</Typography>
    </Box>
    <Box 
      sx={{
        width: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'start',
        alignItems: 'center',
        gap: 4,
        height: 1,
        py: 4,
        backgroundColor: '#1B2229'
      }}>
      <Box
        sx={{
          width: 0.8,
          display: 'flex',
        }}
      >
        <Box
          sx={{
            width: 0.5,
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <Typography variant='h6'>Cantidad</Typography>
        </Box>

        <Box
          sx={{
            width: 0.5,
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <Typography variant='h6'>Canal</Typography>
        </Box>
      </Box>

      {channels.map((channel, index) => (
        <ChannelRow
          key={index}
          icon={channel.icon}
          count={channel.count}
        />
      ))}
    </Box>
    </>
  );
}
